(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["ll-adult-product-photo"] && !Shopify.designMode) return;
  try {
    (function () {
  if (window.llAdultProductPhotoBound) return;
  window.llAdultProductPhotoBound = true;
  document.addEventListener('pdpv2:product-changed', function (event) {
    var nextProduct = event.detail && event.detail.product;
    var main = event.target && event.target.closest && event.target.closest('main, #main');
    if (!main || !nextProduct || nextProduct.id == null) return;
    var nextId = String(nextProduct.id);
    main.querySelectorAll('[data-ll-adult-photo]').forEach(function (slot) {
      var current = slot.querySelector('[data-ll-adult-photo-current]');
      if (!current) return;
      var option = Array.from(slot.querySelectorAll('template[data-ll-adult-photo-option]')).find(function (candidate) {
        if (candidate.getAttribute('data-ll-adult-photo-option') !== nextId) return false;
        return !nextProduct.handle || candidate.getAttribute('data-product-handle') === nextProduct.handle;
      });
      var chosen = option || slot.querySelector('template[data-ll-adult-photo-original]');
      current.replaceChildren();
      if (chosen) current.appendChild(chosen.content.cloneNode(true));
      slot.classList.toggle('is-overridden', !!option);
      slot.setAttribute('data-current-product-id', nextId);
    });
  });
})();
  } catch(e) { console.error(e); }
})();

})();
